module.exports = __webpack_public_path__ + "img/elementheights_jak.72b22c79.png";